'use client';

import { cn } from '@/lib/utils';

const SIZES: Record<string, string> = {
  xs: 'h-3 w-3',
  sm: 'h-3.5 w-3.5',
  md: 'h-4 w-4',
  lg: 'h-5 w-5',
  xl: 'h-6 w-6',
};

interface BoardroomIconProps {
  className?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

/**
 * The canonical Boardroom mark — pixel-art portrait used everywhere the
 * Boardroom is identified as a grid (lobby card, chat headers, claim
 * fees drawer, profile lists, notifications, activity ticker).
 *
 * Renders the same `/boardroom.png` asset that `resolveGridDisplay()`
 * returns for HV grid 0, so a single replacement updates every surface
 * (icon component, `<BoardCover>` consumers, `<Image>` callers) at once.
 *
 * `image-rendering: pixelated` preserves the crisp edges of the pixel
 * art when the icon scales below the source's native 256×256, matching
 * how `mascot.png` and other pixel-art assets render across the app.
 */
export function BoardroomIcon({ className, size = 'md' }: BoardroomIconProps) {
  return (
    <img
      src="/boardroom.png"
      alt=""
      aria-hidden
      className={cn(SIZES[size], 'object-contain shrink-0', className)}
      style={{ imageRendering: 'pixelated' }}
    />
  );
}
